"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPaidHub = exports.provisionPartnerParcels = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

// For upgrading Directory users to HubSpot Partner Agencies
var provisionPartnerParcels = function provisionPartnerParcels(portalId, countryCode) {
  return _apiClient.default.post("/partnerdb/v1/provisioning/touchless?portalId=" + portalId, {
    data: {
      countryCode: countryCode,
      partnerType: 'SALES_SOLUTION'
    }
  });
};

exports.provisionPartnerParcels = provisionPartnerParcels;

var isPaidHub = function isPaidHub() {
  return _apiClient.default.get('/iris-read/v1/app?hubField=paidHub').then(function (payload) {
    return payload.hub.paidHub;
  });
};

exports.isPaidHub = isPaidHub;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/core/utilities/parcelUtils.js
// module id = 788
// module chunks = 5 6